import React from 'react';
import { Button } from '@/components/ui/button';
import { Search, Eye, Copy, Building2 } from 'lucide-react';
import { Link } from 'react-router-dom';

const CommitteeLibraryTab = ({
  allScholarships,
  currentCommitteeId,
  cloneFromLibrary
}) => {
  // Filter out scholarships that belong to the current committee
  const libraryScholarships = allScholarships.filter(
    (s) => s.committee_id !== currentCommitteeId
  );

  return (
    <div className="bg-white rounded-lg border border-slate-200">
      <div className="p-4 border-b border-slate-200 flex flex-col md:flex-row md:items-center justify-between gap-4 bg-slate-50">
        <div>
          <h3 className="font-semibold text-slate-900 flex items-center gap-2">
            <Search className="w-5 h-5 text-greek-blue" />
            Scholarship Form Library
          </h3>
          <p className="text-sm text-slate-500 mt-1">
            Discover and clone application forms and scoring rubrics from other AHEPA & DOP committees.
          </p>
        </div>
      </div>

      {libraryScholarships.length === 0 ? (
        <div className="p-12 text-center">
          <Search className="w-12 h-12 text-slate-300 mx-auto mb-3" />
          <p className="text-slate-600">No external scholarships available in the library yet.</p>
        </div>
      ) : (
        <div className="divide-y divide-slate-200">
          {libraryScholarships.map((scholarship) => (
            <div key={scholarship.id} className="p-5 hover:bg-slate-50 transition-colors">
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                <div className="flex-1">
                  <div className="flex items-center gap-2 mb-1">
                    <h4 className="font-medium text-slate-900">{scholarship.name}</h4>
                    <span className="px-2 py-0.5 rounded-full text-xs font-medium bg-slate-100 text-slate-600">
                      {scholarship.scholarship_type?.replace('_', ' ')}
                    </span>
                  </div>
                  
                  <div className="flex items-center gap-2 mt-2 text-sm text-slate-500">
                    <Building2 className="w-4 h-4" />
                    <span className="font-medium">{scholarship.committee_name || 'Global / Unassigned'}</span>
                  </div>
                  
                  <p className="text-sm text-slate-600 mt-3 line-clamp-2">
                    {scholarship.description}
                  </p>
                </div>
                
                <div className="flex items-center gap-2 md:self-end">
                  <Link 
                    to={`/application/preview/${scholarship.id}`}
                    target="_blank"
                  >
                    <Button variant="outline" size="sm" className="rounded-sm bg-white">
                      <Eye className="w-4 h-4 mr-1" />
                      Preview Form
                    </Button>
                  </Link>
                  <Button 
                    onClick={() => cloneFromLibrary(scholarship)}
                    size="sm" 
                    className="rounded-sm bg-greek-blue hover:bg-blue-700"
                  >
                    <Copy className="w-4 h-4 mr-1" />
                    Clone to My Committee
                  </Button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CommitteeLibraryTab;